/*
 * @Description: 业务公司接口
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-18 21:37:08
 * @LastEditTime: 2019-07-24 14:21:03
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 查询客户列表
export const getCustomerList = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Business/Customer/get`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageDemand'
      }, params))
    }
  })
}
// 查看联系人-联系记录
export const getContactRecord = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Business/Customer/getRecord`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getRecord'
      }, params))
    }
  })
}
// 编辑修改
export const editSubForm = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Business/Customer/update`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'demandEdit'
      }, params))
    }
  })
}
// 新增-公司验证（查重）
export const getAddList = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Business/Customer/getCustomer`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getCustomer'
      }, params))
    }
  })
}
// 新增-提交
export const AddList = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Business/Customer/save`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'demandSave'
      }, params))
    }
  })
}
// 批量删除
export const deleteStrip = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Business/Customer/delete`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'demandRemove'
      }, params))
    }
  })
}
// 批量删除
export const deleteForm = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/Business/Customer/delete`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'batchDel'
      }, params))
    }
  })
}
